import Decimal from 'decimal.js';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { calculateWeight } from './volumeUtils';
import { IbcShipTypeEnum } from 'src/enums/stowage/ibcShipTypeEnum';

export const getMaxStowedWeight = (
    cargo: RotationCargo,
    tankMaxWeight: Decimal,
    tankMaxVolume: Decimal,
    previousTankContentWeight: Decimal,
    weightAvailable: Decimal,
    cargoTemperature: number
): Decimal => {
    // returns the maximum weight that can be filled in the tank
    // the returned weight added to the previousTankContentWeight cannot exceed the tankMaxWeight
    // the maximum volume depends on the cargo type
    // the volume equivalent of the (returned weight added to the previousTankContentWeight) cannot exceed the tankMaxVolume
    // the returned weight cannot exceed the weightAvailable
    // the returned weight should be rounded down to 3 decimal places

    const maxWeightByTankCapacity = tankMaxWeight.minus(previousTankContentWeight);
    const maxVolumeForCargoType = getMaxVolumeForCargoType(cargo);
    const maxVolume = Decimal.min(tankMaxVolume, maxVolumeForCargoType);
    const maxWeightByVolumeCapacity = calculateWeight(maxVolume, cargo, cargoTemperature).minus(previousTankContentWeight);
    const maxStowedWeight = maxWeightByTankCapacity.lt(maxWeightByVolumeCapacity)
        ? maxWeightByTankCapacity.lt(weightAvailable)
            ? maxWeightByTankCapacity
            : weightAvailable
        : maxWeightByVolumeCapacity.lt(weightAvailable)
        ? maxWeightByVolumeCapacity
        : weightAvailable;

    return maxStowedWeight.toDecimalPlaces(3);
};

export const getMaxUnstowedWeight = (previousTankContentWeight: Decimal, weightAvailable: Decimal): Decimal => {
    return Decimal.min(previousTankContentWeight, weightAvailable);
};

export const getMaxVolumeForCargoType = (cargo: RotationCargo): Decimal => {
    return new Decimal(
        cargo.product.category.shipType === IbcShipTypeEnum.One ? 1250 : cargo.product.category.shipType === IbcShipTypeEnum.Two ? 3000 : 99999
    );
};
